// extracted by mini-css-extract-plugin
export default {"select":"Select_select__t1Oxn","default":"Select_default__za26y","small":"Select_small__cV85i","large":"Select_large__zbvpu"};